import React, { Component } from 'react'
import * as pixi from 'pixi.js';
import { Blobber } from 'src/components/blobber/Blobber';
import _map from 'lodash/map';
import './BlobFiller.scss';

export class BlobFiller extends Component {
  componentDidMount() {
    const { fills, fill, width, height } = this.props;
    let fillList = [];
    if (!fills && fill) {
      fillList = [fill];
    }
    else {
      fillList = fills;
    }

    this.app = new pixi.Application({
      width,
      height,
      transparent: true,
      antialias: true,
    });
    this.blobs = _map(fillList, props => new BlobFillerCanvas({ ...props, app: this.app }));

    this.refs.fills.appendChild(this.app.view);
    if (this.props.isInView) {
      _map(this.blobs, blob => blob.start());
    }

  }

  componentWillUnmount() {
    _map(this.blobs, blob => blob.destroy());
    this.app.destroy();
  }

  componentWillReceiveProps(props) {
    if (this.props.isInView === props.isInView) return;
    if (props.isInView) {
      _map(this.blobs, blob => {
        blob.stop();
        blob.start();
      });
    }
    else {
      _map(this.blobs, blob => {
        blob.stop();
      });
    }
  }

  render() {
    const { x, y } = this.props;
    return (
      <div className="BlobFiller" ref="fills" style={{ left: x, top: y }}>
      </div>
    );
  }
}


class BlobFillerCanvas {
  blob = null;

  constructor({ anchors, x, y, color, alpha = .5, app = null, wobbleVariation }) {
    if (!anchors || anchors.length === 0) {
      throw new Error('Anchors are needed');
      return;
    }
    const blob = new Blobber({ alpha, color, x, y, anchors });
    this.wobbleVariation = wobbleVariation;
    if (app) {
      blob.useSharedCanvas({ app });
    }

    this.blob = blob;
  }

  start() {
    let positionVariation = 5;
    if (this.wobbleVariation) {
      const { position } = this.wobbleVariation;
      if (position != null) {
        positionVariation = position;
      }
    }
    this.blob.startWobbling({
      wobble: {
          position: () => ({ min: -positionVariation, max: positionVariation }),
          length: (length) => ({ min: length * .8, max: length * 1.2 }),
          angle: (angle) => ({ min: -Math.PI / 20, max: Math.PI / 20 }),
      },
      timeRange: { min: 700, max: 2500 },
    });
  }

  destroy() {
    this.stop();
  }

  stop() {
    this.blob.stopWobbling();
  }
}

